/*
 * @Descripttion: 封装数据请求
 * @Author: juanjuanhui
 * @Date: 2021-05-17 09:25:08
 * @LastEditors: likk 1126919170@qq.com
 * @LastEditTime: 2024-09-25 11:20:14
 */
import axios from "axios";
import { Toast } from "vant";
import qs from "qs";
import store from "@/store";
import { Base64 } from "../js/base64js";
// 1.创建新的axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000,
});
// 2.请求拦截器
service.interceptors.request.use(
  (config) => {
    // 发请求前做的一些处理，数据转化，配置请求头等，根据需求去添加
    const { accessToken,otherAccessToken, 
      // wfwAccessToken
    }= store.state;
    // if (config.serviceType=="weifuwu") {//微服务接口
    //   config.headers.Authorization = wfwAccessToken || `Basic ${Base64.encode("njwst:njwst")}`;
    // }else{
      config.headers.Authorization = accessToken || otherAccessToken;
    // }
    /**
     * 判断请求的类型
     * 如果是post请求就把默认参数拼到data里面
     * 如果是get请求就拼到params里面
     */
    if (config.method === "post") {
      let contentType = config.contentType;
      if (contentType && contentType == "application/x-www-form-urlencoded") {
        let data = qs.parse(config.data);
        config.data = qs.stringify({
          ...data,
        });
        config.headers = {
          "Content-Type": contentType,
          "Cache-Control": "no-cache",
        };
      } else if (config.isObj) {
        let data = config.data;
        config.data = {
          ...data,
        };
      }
    } else if (config.method === "get") {
      config.params = {
        ...config.params,
      };
    }
    config.headers["Cache-Control"] = "no-cache";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 3.响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if(res.code==200){
      if(res.data && !res.data.statusCode){
        return res.data;
      }else if(res.data && res.data.statusCode == 200){
        return res.data.result
      }
      Toast(res.data.statusMsg || res.msg )
      return Promise.reject(new Error(res.data.statusMsg || res.msg || "Error"));
    }else if(res.code==401 
      // || res.code =="10002"
    ){
      // if(response.config.serviceType=="weifuwu"){//微服务接口token失效
      //   store.dispatch("GetWFWAccessToken");
      // }else{
        if(store.state.accessToken){//登录状态token失效-重新刷新token
          store.dispatch("RefreshToken");
        }else{//第三方token失效
          store.dispatch("GetOtherAccessToken");
        }
      // }
      return service(response.config);
    }else{
      return Promise.reject(new Error(res.data.statusMsg || res.msg || "Error"));
    }
  },
  (error) => {
    console.log("error-",error)
    Toast({
      message: error.message,
      type: "fail",
      duration: 2000,
    });
    return Promise.reject(error);
  }
);
export default service;
